export const CONTINUE = "activation.settings.modal.cancel.btn.confirm.text";
export const CANCEL = "activation.settings.modal.cancel.btn.cancel.text";
export const TITLE = "activation.settings.modal.cancel.title.text";
export const MAIN_TEXT = "activation.settings.modal.cancel.body.text";
export const OVER_THE_LIMIT = "activation.settings.modal.body.over_the_limit.text";
